<div class="home-empty" aria-label="Home center content area">
  <nav class="breadcrumb" aria-label="Breadcrumb">
    <span class="breadcrumb-current">Home</span>
  </nav>

  <div class="record-details-header">
    <h1 class="record-details-title">Record Details</h1>

    <div class="record-details-right-aln">
      <div class="record-search">
        <span class="icon record-search-icon">search</span>
        <input class="record-search-input" type="text" placeholder="Search by Record ID..." [value]="searchQuery"
          (input)="onSearchChange($any($event.target).value)" aria-label="Search records by Record ID"
          [disabled]="isLoading" />
      </div>
      <div class="upload-file">
        <button type="button" class="upload-btn" (click)="uploadFiles()">Upload</button>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div class="loading-state" *ngIf="isLoading">
    <p>Loading records...</p>
  </div>

  <!-- Error State -->
  <div class="error-state" *ngIf="errorMessage && !isLoading">
    <p class="error-message">{{ errorMessage }}</p>
    <button type="button" class="retry-button" (click)="ngOnInit()">Retry</button>
  </div>

  <!-- Table -->
  <app-data-table *ngIf="!isLoading && !errorMessage" [columns]="recordDetailsColumns" [rows]="pagedReviews"
    [clickableKey]="'record_id'" (rowClick)="onRecordIdClick($event)"></app-data-table>

  <!-- Pagination -->
  <div class="pagination-controls" *ngIf="!isLoading && !errorMessage" aria-label="Record details pagination">
    <span class="pagination-meta">
      Showing {{ startRecordIndex }}-{{ endRecordIndex }} of {{ totalRecords }} (Page {{ currentPage }} of {{ totalPages
 }})
    </span>

    <button type="button" class="pagination-icon-button icon" (click)="goToPreviousPage()"
      [disabled]="currentPage === 1" aria-label="Previous page">
      chevron_left
    </button>

    <button type="button" class="pagination-icon-button icon" (click)="goToNextPage()"
      [disabled]="currentPage === totalPages" aria-label="Next page">
      chevron_right
    </button>
  </div>
</div>

<ng-template #dialogTemplate>
  <mat-dialog-content>

    <section class="upload-modal">
      <h2>Upload File</h2>
      <p>Only <b>.docx</b> files are allowed</p>

      <!-- Upload area -->
      <div class="upload-box" (click)="fileInput.click()">
        <mat-icon>cloud_upload</mat-icon>
        <span>Click to upload</span>
        <small>.docx only</small>

        <input
          #fileInput
          type="file"
          accept=".docx"
          hidden
          (change)="onFileSelected($event)"
        />
      </div>

      <!-- File name -->
      <div class="file-name" *ngIf="selectedFileName">
        <mat-icon>description</mat-icon>
        {{ selectedFileName }}
      </div>
    </section>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      mat-stroked-button
      color="primary"
      (click)="updateUploadFiles()"
      [disabled]="!selectedFileName">
      Upload
    </button>

    <button
      mat-flat-button
      color="primary"
      cdkFocusInitial
      (click)="submitUploadFile()"
      [disabled]="!fileUploadedFlag">
      Submit
    </button>
  </mat-dialog-actions>
</ng-template>